import PropTypes from 'prop-types'
import { forwardRef, memo } from 'react'

const SVGStandard = forwardRef((props, forwardedRef) => {
  const { isBeta, uid, ...attributes } = props

  return (
    <svg ref={forwardedRef} viewBox="0 0 380.162 48.412" {...attributes}>
      <linearGradient id={uid} x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" />
        <stop offset="100%" />
      </linearGradient>
      <g data-i>
        <path d="M2.9,41.7l28.7-8.1v11L2.9,41.7z M65.3,31l-30.2-7.4V22c0-0.3,0.8-1.1,1.5-1.7c1.7-1.6,4.3-4.1,4.3-8.7 c0-5.8-3.3-9.2-8.8-9.2c-4.3,0-8.8,3-8.8,8.6h4.3c0-1.5,0.5-2.6,1.5-3.3c1-0.7,2.2-1,3-1c3.1,0,4.5,1.5,4.5,4.9c0,2.7-1.4,4.1-3,5.5 c-1.3,1.2-2.8,2.7-2.8,4.8v1.6L0.6,31C0.2,31.1,0,31.4,0,31.7v5.5c0,0.5,0.5,0.8,0.9,0.7l30.8-8.2l1.1-0.3c0.1,0,0.3,0,0.4,0 l1.1,0.3L65,37.9c0.5,0.1,0.9-0.2,0.9-0.7v-5.5C65.9,31.4,65.6,31.1,65.3,31z M34.2,44.6l28.7-2.9l-28.7-8.1V44.6z" />
      </g>
      <g data-l1>
        <path
          id="Diamond_00000095331072610519233430000000026208040277587349_"
          d="M108.319,4.3h9.02l9.72,39.89h-8.087L108.319,4.3z
M95.255,4.3h8.864l9.798,39.89h-8.009L95.255,4.3z M101.01,44.19H87.169l3.655-36.235L101.01,44.19z M149.997,4.3v6.843h-10.575
v15.94h9.487v6.843h-9.487v3.421h10.575v6.843H131.88V4.3H149.997z M154.74,4.3h22.239v6.843h-7.387V44.19h-7.543V11.142h-7.387
L154.74,4.3z M189.343,4.3c8.242,0,14.93,6.609,14.93,14.852c-0.078,4.588-2.177,8.864-5.676,11.664l5.676,13.374h-7.543
l-4.51-10.575c-0.933,0.156-1.944,0.311-2.877,0.311V44.19H181.8V4.3H189.343z M196.73,19.152c0-4.432-3.344-8.009-7.387-8.009
v15.94C193.464,27.083,196.73,23.506,196.73,19.152z M258.548,4.3c8.165-0.156,15.007,6.298,15.163,14.463
c0.156,8.165-6.298,15.007-14.463,15.163c-0.233,0-0.467,0-0.7,0V44.19h-7.543V4.3H258.548z M266.013,19.152
c0-4.432-3.344-8.009-7.387-8.009v15.94C262.669,27.083,266.013,23.506,266.013,19.152z M352.557,4.3v39.89h-7.543V4.3H352.557z
 M340.272,37.347v6.843H329.93v-6.843H340.272z M328.064,4.3v39.89h-7.543V4.3H328.064z M368.731,44.19
c-4.821,0-9.331-2.333-10.886-6.532l6.998-3.11c0,1.555,1.711,2.877,3.888,2.877s3.888-1.322,3.888-2.877
c0-3.655-15.318-6.298-15.318-18.506c0-6.843,5.599-11.741,12.441-11.741c5.676,0,10.42,4.354,10.42,9.72
c-0.078,4.432-3.188,8.32-7.543,9.331l-2.877-6.454c1.555,0.078,2.955-1.166,3.033-2.722c0.078-1.555-1.166-2.955-2.722-3.033
c-0.078,0-0.233,0-0.311,0c-2.722,0-4.899,2.177-4.899,4.899l0,0c0,7.698,15.318,8.242,15.318,18.506
C380.162,40.691,374.641,44.19,368.731,44.19z M316.011,24.206c0,11.042-8.476,20.062-18.973,20.062
c-10.42,0-18.973-9.02-18.973-20.062c0-10.497,8.009-20.062,18.973-20.062C307.458,4.144,316.011,13.164,316.011,24.206z
 M297.038,37.425c6.298,0,11.43-5.91,11.43-13.219s-5.132-13.219-11.43-13.219c-6.998,0-11.43,6.843-11.43,13.219
C285.608,31.515,290.74,37.502,297.038,37.425L297.038,37.425z M246.34,24.206c0,11.042-8.476,20.062-18.973,20.062
c-10.42,0-18.895-9.02-18.895-20.062c0-10.497,8.009-20.062,18.973-20.062C237.864,4.144,246.34,13.164,246.34,24.206z
 M227.444,37.425c6.298,0,11.43-5.91,11.43-13.219s-5.132-13.219-11.43-13.219c-6.998,0-11.43,6.843-11.43,13.219
C216.014,31.515,221.146,37.502,227.444,37.425L227.444,37.425z"
        />
        {isBeta && (
          <path
            fillOpacity="0.75"
            d="M331.623-8.439c0.564-0.289,0.991-0.61,1.281-0.96c0.518-0.625,0.777-1.453,0.777-2.481c0-0.999-0.259-1.857-0.777-2.573 c-0.863-1.167-2.326-1.766-4.392-1.796h-8.19V0.609h7.64c0.861,0,1.66-0.076,2.397-0.229c0.736-0.153,1.375-0.434,1.915-0.846 c0.48-0.358,0.881-0.801,1.201-1.326c0.503-0.792,0.755-1.689,0.755-2.688c0-0.969-0.219-1.792-0.657-2.47 C333.134-7.63,332.484-8.126,331.623-8.439z M323.685-13.322h3.705c0.816,0,1.488,0.088,2.013,0.263 c0.61,0.252,0.915,0.77,0.915,1.556c0,0.709-0.229,1.201-0.687,1.476c-0.465,0.282-1.068,0.423-1.806,0.423h-4.14 C323.685-9.605,323.685-13.322,323.685-13.322z M329.553-2.617c-0.412,0.199-0.988,0.297-1.727,0.297h-4.14v-4.494h4.198 c0.732,0.008,1.3,0.102,1.703,0.286c0.725,0.327,1.087,0.931,1.087,1.808C330.672-3.685,330.3-2.983,329.553-2.617z M340.727-2.423 h9.332v3.031h-12.775v-16.858h12.363v2.986h-8.921v3.58h8.19v2.928h-8.19v4.334H340.727z M365.054-13.266h-5.044V0.608h-3.546 v-13.874h-5.067v-2.986h13.656V-13.266L365.054-13.266z M374.192-16.251h-3.981l-6.016,16.858h3.683l1.167-3.466h6.21l1.087,3.466 h3.821L374.192-16.251z M369.994-5.762l2.174-6.634l2.104,6.634H369.994z"
          />
        )}
      </g>
    </svg>
  )
})

// The display name
SVGStandard.displayName = 'SVGStandard'

/** @type {object} */
SVGStandard.propTypes = {
  uid: PropTypes.string.isRequired,
  isBeta: PropTypes.bool
}

/** @type {object} */
SVGStandard.defaultProps = {
  isBeta: false
}

// Memoize
export default memo(SVGStandard)
